import { defineStore } from 'pinia'

export const useInteractiveMap = defineStore('interactiveMap', {
  id: 'components',
  state: () => ({
    isLoadingTraffic: false,
    isLoadingPrediction: false,
    predictArrivalsDepartures: null,
    predictTrafficData: null,
    cityCount: null,
    mapType: 'transport',
    predictionDays: 0,
  }),
  actions: {
    togleIsLoadingPrediction() {
      this.isLoadingPrediction = !this.isLoadingPrediction
    },
    togleIsLoadingTraffic() {
      this.isLoadingTraffic = !this.isLoadingTraffic
    },
    changeMapType(mapType) {
      this.mapType = mapType
    },
    getPredictTrafficData(predictTrafficData) {
      this.predictTrafficData = predictTrafficData
    },
    getCityCount(cityCount) {
      this.cityCount = cityCount
    },
    getPredictArrivalsDepartures(predictArrivalsDepartures) {
      this.predictArrivalsDepartures = predictArrivalsDepartures
    },
    getPredictionDays(predictionDays) {
      this.predictionDays = predictionDays
    },
  },
})
